'use strict';

const { getURL } = require('core/apiURLBuilder');
const { post } = require("services/api");
const DateHelper = require('utilities/dateHelper');
const { getPersonTypeAndCode } = require('utilities/hash');

const DATE_FORMAT_BIG_DATA = 'YYYYMMDD';
const MAXIMUM_EVENTS_QUEUE_SIZE = 10;
const TIMEOUT_BEFORE_SENDING = 15000; // in milliseconds
const CHANNEL_ID = 2; // @hardcoded
const CHANNEL_NAME = "WebPrivada"; // @hardcoded
const LOGIN_STATUS = "SUCCESSFUL"; // @hardcoded
const DEVICE = "desktop"; // @hardcoded

/*
    See http://gitlab.aws.ok-cloud.net/commons/analytics-api/blob/master/src/gt.js

    Spec at: https://docs.google.com/document/d/1h01Kb0BP89243EUn6_z9L1pRQ4WlsVCz6_H00Ep0vhE/edit
*/
require("vendor/eventStreaming/streaming.js");

const fingerprint = window.cookieBite.getFingerprint;
const stringHash = window.cookieBite.getStringHash;
const HASH_SEED = 4754;
let counter = 1000000;

let eventsQueue = {
    entries: []
};

const sendEventsAndClear = () => {
    if (eventsQueue.entries.length) {
          if (!__CONTACT_CENTER__) {
        post(getURL('eventStreaming'), {
                header: {},
                query: eventsQueue
            })
            .catch((e) => {
                window.console.log("FAILURE SENDING EVENTS!!", e);
            });
}
        eventsQueue = {entries:[]};
    }
}

const addToQueue = (e) => {
    let metaTags = Array.prototype.slice.call(document.getElementsByTagName("meta"));
    metaTags = metaTags.map((x) => {
        let t = {};
        let z = Array.prototype.slice.call(x.attributes);
        z.forEach(i => {
            t[i.nodeName] = i.nodeValue;
        });
        return t;
    });

    const timestamp = new Date().getTime();
    const timestampReception = timestamp;
    const timeZone = String(new Date().getTimezoneOffset() / 60);
    const browserFingerprint = stringHash(fingerprint(), HASH_SEED);
    const yyyymmdd = DateHelper.formatDate(new Date(), DATE_FORMAT_BIG_DATA);
    const counter6 = String(++counter).substr(-6);
    const cookieExpire = window.cookieBite.getExpiryTime();
    const cookieHash = `${browserFingerprint}-${yyyymmdd}-${counter6}-${cookieExpire}`;
    const view = stringHash(document.location.hostname + document.location.pathname + Date.now() + Math.random(), HASH_SEED);

    let userId = ""; // Get user id, as seen in tagging.js
    try {
        const personTypeAndCode = getPersonTypeAndCode();
        userId = `${personTypeAndCode.type}${Number(personTypeAndCode.f)}`;
    } catch (e) {
        userId = '';
    }

    const newEvent = Object.assign({}, e, {
        "channel": {
            "id": CHANNEL_ID,
            "name": CHANNEL_NAME
        },
        "loginStatus": LOGIN_STATUS,
        "page": {
            "documentHeight": document.body.clientHeight,
            "documentWidth": document.body.clientWidth,
            "host": location.origin,
            metaTags,
            "path": window.location.pathname, // path where content is being rendered
            "referrer": document.referrer || null, //last page were user was on
            "title": document.title
        },
        "visitor": { //browser settings and details
            browserFingerprint,
            timeZone,
            "system": {
                "device": DEVICE,
                "navigator": {
                    "language": navigator.language,
                    "userAgent": navigator.userAgent
                },
                "screen": {
                    "availableHeight": window.screen.availHeight,
                    "availableWidth": window.screen.availWidth
                }
            },
            "user": {
                "id": userId
            },
        },
        "additionalInfo": {
            cookieHash,
        },
        timestamp,
        timestampReception,
        view
    });

    delete newEvent.isTrusted;

    eventsQueue.entries.push(newEvent);
    (eventsQueue.entries.length > MAXIMUM_EVENTS_QUEUE_SIZE) && sendEventsAndClear();
}

const addEventToQueue = (e) => {
    const baseElement = e.path && e.path.find((x) => !!x.id);
    const reportedId = baseElement && baseElement.id || "N/A";

    addToQueue(Object.assign({}, e, {
        "type": "event",
        "component": {
            "id": reportedId,
            "left": e.offsetLeft,
            "top": e.offsetTop,
            "name": "N/A",
            "type": e.path && e.path[0].nodeName
        },
        "action": {
            "name": e.type,
            "cursor": {
                "x": e.pageX,
                "y": e.pageY,
                "scrollTop": document.body.scrollTop,
                "scrollMax": document.body.scrollHeight
            }
        }
    }));
};

const addPageViewToQueue = (e) => {
    addToQueue(Object.assign({}, e, {
        "type": "pageview"
    }));
};

const listenerOptions = {
    capture: true,
    passive: true
};

document.addEventListener("click", addEventToQueue, listenerOptions);
document.addEventListener("beforeunload", sendEventsAndClear, listenerOptions);
window.setInterval(sendEventsAndClear, TIMEOUT_BEFORE_SENDING);

module.exports = {
    addPageViewToQueue
}
